import { render } from "./RecoverPassword.vue?vue&type=template&id=35e9ec99"
import script from "./RecoverPassword.vue?vue&type=script&lang=js"
export * from "./RecoverPassword.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./style.css?vue&type=style&index=0&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__